<template>  
  <div>
    <div class="widget-cbf-panel" v-if="indicators">
      <div class="widget-cbf-header">
        <div class="row">
          <div :class="'col-md-' + indicators.cols" v-for="item in indicators.data" :key="item.reference">          
            <div class="widget-cbf-border-start widget-cbf-border-start-4 py-1 px-3" :style="item.color ? { borderLeftColor: item.color } : null">
              <div class="font-weight-bold widget-cbf-text-secondary-default">{{item.title}}</div>
              <div class="font-weight-bold" v-html="item.value"></div>
            </div>
          </div>        
        </div>
      </div>
    </div>    
    
    <BarChart :chartData="chartData" :options="options" />        
  </div>
  
</template>

<script>
  import BarChart from './_chartBar'

  export default {
    components: {
      BarChart
    },
    props: {
      chartData: {
        type: Object,
        default: {}
      },
      options: {
        type: Object,
        default: {}
      }, 
      indicators: {
        type: Object,
        default: {},
      }     
    },        
  }
</script>
<style>
  .widget-cbf-border-start-4 {
    border-left-width: 4px !important;
  }  
  .widget-cbf-border-start {
    border-left: 1px solid var(--app-color-primary);
  }

  .widget-cbf-border-start-info {
    border-left-color: var(--app-color-primary) !important;
  }  
  .widget-cbf-border-start-success {
    border-left-color: var(--app-color-success) !important;
  }

  .widget-cbf-text-secondary-default {
      --cui-text-opacity: 1;
      color: var(--app-color-text-muted) !important;
  }
  .widget-cbf-panel {
    overflow: hidden;
    margin-bottom: 12px;
    border: 1px solid var(--app-color-border);
    border-radius: 9px;
    background: var(--app-color-surface-subtle);
  }
  .widget-cbf-header {
    padding: 7px 2px;
  }
</style>
